const BACKEND = process.env.REACT_APP_BACKEND_URL;

const PALETTES = {
    default: ["#1B2A4E", "#C8102E", "#0EA5E9", "#059669", "#7C3AED", "#EA580C", "#DB2777"],
    parent: ["#7C3AED", "#DB2777", "#BE185D", "#9333EA", "#EC4899", "#8B5CF6", "#6D28D9"],
};

function colorFor(name, role) {
    const palette = role === "parent" ? PALETTES.parent : PALETTES.default;
    if (!name) return palette[0];
    let h = 0;
    for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) & 0xffff;
    return palette[h % palette.length];
}

export default function Avatar({ url, name, seed, role, size = 36, className = "" }) {
    const displaySeed = seed || name || "؟";
    const initial = displaySeed.replace("ولي أمر / ", "").trim().charAt(0);
    const style = { width: size, height: size, fontSize: Math.max(11, Math.floor(size * 0.4)) };
    if (url) {
        const src = url.startsWith("http") ? url : `${BACKEND}${url}`;
        return (
            <img
                src={src}
                alt={name || "avatar"}
                style={style}
                className={`rounded-full object-cover ring-2 ring-white shrink-0 ${className}`}
            />
        );
    }
    const bg = colorFor(displaySeed, role);
    if (role === "parent") {
        return (
            <div
                style={{ ...style, background: `linear-gradient(135deg, ${bg}, #DB2777)` }}
                className={`rounded-full flex items-center justify-center text-white font-bold shrink-0 shadow-sm relative ${className}`}
            >
                {initial}
                <div style={{ fontSize: Math.max(8, Math.floor(size * 0.22)) }} className="absolute -bottom-0.5 -left-0.5 bg-white text-pink-600 rounded-full p-0.5 leading-none">♥</div>
            </div>
        );
    }
    return (
        <div style={{ ...style, backgroundColor: bg }} className={`rounded-full flex items-center justify-center text-white font-bold shrink-0 ${className}`}>
            {initial}
        </div>
    );
}
